"use client";

import { useGetMeQuery, useLogoutMutation } from "@/query/twitter";
import { useAuthStore } from "@/redux/hooks";
import {
  Address,
  Avatar,
  EthBalance,
  Identity,
  Name,
} from "@coinbase/onchainkit/identity";
import { useAddFrame, useMiniKit } from "@coinbase/onchainkit/minikit";
import {
  ConnectWallet,
  Wallet,
  WalletDropdown,
  WalletDropdownDisconnect,
} from "@coinbase/onchainkit/wallet";
import { useRouter } from "next/navigation";
import { Suspense, useCallback, useEffect, useMemo, useState } from "react";
import { Button, Icon } from "./components/DemoComponents";

function AppContent() {
  const { setFrameReady, isFrameReady, context } = useMiniKit();
  const [frameAdded, setFrameAdded] = useState(false);
  const { mutateAsync: logout } = useLogoutMutation();
  const [localRefreshToken, setLocalRefreshToken] = useState<string | null>(
    null,
  );
  const [localAccessToken, setLocalAccessToken] = useState<string | null>(null);

  const router = useRouter();
  const { me } = useAuthStore();

  useEffect(() => {
    // 1. Read from URL params
    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get("accessToken");
    const refreshToken = params.get("refreshToken");

    // 2. If found, save to localStorage
    if (accessToken) localStorage.setItem("accessToken", accessToken);
    if (refreshToken) localStorage.setItem("refreshToken", refreshToken);

    // 3. Always read latest from localStorage
    setLocalAccessToken(localStorage.getItem("accessToken"));
    setLocalRefreshToken(localStorage.getItem("refreshToken"));
  }, []);

  const { data } = useGetMeQuery(!me);

  // const [activeTab, setActiveTab] = useState("home");

  const addFrame = useAddFrame();
  // const openUrl = useOpenUrl();

  useEffect(() => {
    if (!isFrameReady) {
      setFrameReady();
    }
  }, [setFrameReady, isFrameReady]);

  const handleAddFrame = useCallback(async () => {
    const frameAdded = await addFrame();
    setFrameAdded(Boolean(frameAdded));
  }, [addFrame]);

  async function handleLogout() {
    const localRefreshToken = localStorage.getItem("refreshToken");
    console.log({ localRefreshToken });

    if (localRefreshToken) {
      console.log("logout");
      await logout(localRefreshToken);
    }
  }

  if (data) {
    console.log({ data });
  }

  const saveFrameButton = useMemo(() => {
    if (context && !context.client.added) {
      return (
        <Button
          variant="ghost"
          size="sm"
          onClick={handleAddFrame}
          className="text-[var(--app-accent)] p-4"
          icon={<Icon name="plus" size="sm" />}
        >
          Save Frame
        </Button>
      );
    }

    if (frameAdded) {
      return (
        <div className="flex items-center space-x-1 text-sm font-medium text-[#0052FF] animate-fade-out">
          <Icon name="check" size="sm" className="text-[#0052FF]" />
          <span>Saved</span>
        </div>
      );
    }

    return null;
  }, [context, frameAdded, handleAddFrame]);

  return (
    <div className="flex flex-col min-h-screen font-sans text-[var(--app-foreground)] mini-app-theme from-[var(--app-background)] to-[var(--app-gray)]">
      <div className="w-full max-w-md mx-auto px-4 py-3">
        <header className="flex justify-between items-center mb-3 h-11">
          <div>
            <div className="flex items-center space-x-2">
              <Wallet className="z-10">
                <ConnectWallet>
                  <Name className="text-inherit" />
                </ConnectWallet>
                <WalletDropdown>
                  <Identity className="px-4 pt-3 pb-2" hasCopyAddressOnClick>
                    <Avatar />
                    <Name />
                    <Address />
                    <EthBalance />
                  </Identity>
                  <WalletDropdownDisconnect />
                </WalletDropdown>
              </Wallet>
            </div>
          </div>
          <h1>lksfjkelf</h1>
          <div className="text-red-500">{saveFrameButton}</div>
        </header>
        <button
          onClick={() => {
            router.push("/login");
          }}
          className="mr-10"
        >
          Login
        </button>
        <button
          onClick={handleLogout}
          className="border border-black p-2 rounded-md"
        >
          Logout
        </button>
        <div>
          {me?.userId}
          {me?.twitterUsername}
        </div>
        <div>
          {localAccessToken}
          {localRefreshToken}
        </div>

        {/* <main className="flex-1">
          {activeTab === "home" && <Home setActiveTab={setActiveTab} />}
          {activeTab === "features" && <Features setActiveTab={setActiveTab} />}
        </main>

        <footer className="mt-2 pt-4 flex justify-center">
          <Button
            variant="ghost"
            size="sm"
            className="text-[var(--ock-text-foreground-muted)] text-xs"
            onClick={() => openUrl("https://base.org/builders/minikit")}
          >
            Built on Base with MiniKit
          </Button>
        </footer> */}
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <AppContent />
    </Suspense>
  );
}
